export default {
  categoryInfo: {
    mainTitle: 'Zorunlu Trafik Sigortası',
    description: {
      title: 'Zorunlu Trafik Sigortası Nedir?',
      content: [
        'Zorunlu trafik sigortası 2918 sayılı Karayolu Trafik Kanunu çerçevesinde düzenlenen sigorta çeşididir. Trafikte bulunan her aracın trafik sigortası yaptırması ve her yıl düzenli olarak yenilemesi kanunen zorunludur.'
      ]
    },
    subContent: {
      title: 'Trafik Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph: 'Evet, trafik sigortası yaptırmak zorunludur.',
          subList: null
        },
        {
          paragraph:
            'Karayolları Trafik Kanunu çerçevesinde belirlenen açıklamanın başında Türkiye’de her türlü motorlu taşıt sahibi trafik sigortası yaptırmakla yükümlü olduğu yer almaktadır. Trafikte bulunan araçların trafik sigortası olmadığı tespit edilirse trafik polisi tarafından sigortasız araç bağlanır.',
          subList: null
        },
        {
          paragraph:
            'Tarik sigortası olmayan araç sürücüsü kazaya karışırsa, üçüncü şahıslara verilen zararı kendi bütçesinden ödemek zorunda kalır. Tüm bu durumlarla karşılaşmamak için zorunlu trafik sigortanızı her yıl yenilemelisiniz.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Trafik Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Trafik Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Trafik Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Trafik Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası trafikte meydana gelebilecek bir kaza sonucunda üçüncü şahıslara vereceğiniz maddi ve bedeni zararlar karşılanır. Olası trafik risklerini göz önünde bulundurarak trafik sigortanızı yaptırmalısınız.',
          subList: null
        },
        {
          paragraph:
            'Yapılması kanunen zorunlu olan trafik sigortası aracın bir kazaya karışması durumunda karşı tarafa verilebilecek maddi ve bedeni zararları güvence altına alır. Herhangi bir kaza veya hasar durumunda her iki tarafın da kusur oranları hesaplanarak zararı karşılar.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik ve Kasko Sigortası Arasındaki Farklar Nelerdir?',
      content: [
        {
          paragraph:
            'Araç trafik sigortası üçüncü şahıslar için ödeme yapmaktadır. Bu noktada araç sürücülerinin iki sigorta ürünü arasındaki farkları bilmesi son derece önemlidir.',
          subList: [
            'Kasko sigortası isteğe bağlı yapılan sigorta çeşididir. Fakat trafik sigortası yaptırmak zorunludur ve trafikte yer alan tüm araç sahiplerini kapsar. Aksi durumda yapılmadığı an cezai işlem uygulanır.',
            'Zorunlu trafik sigortası kaza durumunda karşı sürücünün haklarını temin ederken kasko sigortası araç sahibinin aracına karşı güvence sunar.',
            'Trafik sigortası kaza anında karşı tarafın sorumluluğunu alıp araç sahibini maddi yükümlülükten korurken kasko sigortası araç sahibin aracında oluşan hasarların maddi sorumluluğunu alır.',
            'Trafik sigortası fiyatlarının belirlenmesindeki en büyük faktör olan teminat limitleri her yıl devlet tarafından belirlenir. Fakat kasko sigortası fiyatları araç sürücüsüne bağlı değiştiği gibi poliçe kapsamına alınan teminatlarda fiyatı belirler. Bu doğrultuda aslında kasko fiyatlarını araç sürücüsü belirleyebilir.',
            'Kasko poliçesinde tavan fiyat uygulaması yer almazken, zorunlu trafik sigortası kapsamında belirlenmiş olan tavan fiyat vardır.',
            'Trafik sigortasının teminat limitleri sigorta şirketleri arasında değişlik göstermediği için en ucuz trafik sigortası fiyatını tercih edebilirsiniz. Fakat kasko sigortasında en ucuz fiyat değil, en doğru teminata odaklanmalısınız.'
          ]
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası olan bir aracın kazaya karışması durumunda;',
          subList: [
            'Maddi hasar,',
            'Sağlık giderleri,',
            'Sakatlanma ve ölüm teminatı devreye girer.'
          ]
        },
        {
          paragraph:
            'Bu kapsamda oluşan kazalarda poliçe limitleri dâhilinde giderler karşılanır.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Türkiye sınırları içerisinde geçerli olan zorunlu trafik sigortası teminatları;',
          subList: [
            'Maddi Zarar Teminatı: Zarar görmüş aracın giderlerini karşılar.',
            'Sağlık Giderlerinin Teminatı: Kazaya karışan karşı sürücünün kaza sırasında uğrayacağı sağlık risklerini güvence altına alan teminattır. Kişinin alacağı tüm tedavi masrafları poliçe kapsamı doğrultusunda SGK sorumluluğunda değerlendirilir.',
            'Sakatlık Teminatı: Meydana gelen trafik kazası sonucunda üçüncü kişilerde oluşacak kalıcı sakatlık giderlerine karşı güvence sağlayan teminattır.',
            'Vefat Teminatı: Trafik sigortası kapsamında meydana gelen kazada karşı sürücünün vefat etmesi sonucunda geride kalanlarına ödenecek tazminatı kapsar.'
          ]
        }
      ]
    },
    {
      title: 'Motosiklet Trafik Sigortası Nedir?        ',
      content: [
        {
          paragraph:
            'Motosiklet trafik sigortası, motosiklet sahiplerinin trafikte karşı sürücüye vereceği zararları güvence altına alan sigorta türüdür.',
          subList: null
        },
        {
          paragraph:
            'Motosiklet trafik sigortası, motosikletinizde oluşan zarar ve karşılamamaktadır. Trafik sigortası genel şartları kapsamında sadece üçüncü şahıslara verilen zararlar karşılar.',
          subList: null
        }
      ]
    },
    {
      title: 'Aylık Trafik Sigortası Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu trafik poliçesi aylık olarak yapılmamaktadır. Tanzim tarihi ile başlayarak bir yıl geçerlidir.',
          subList: null
        },
        {
          paragraph:
            'Aracınızı sattığınız durumda kalan süre için trafik sigortası iptali yapılarak iade alınabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası Yaptırılmazsa Ne Olur?',
      content: [
        {
          paragraph:
            'Trafik sigortası bulunmayan araçların trafiğe çıkmaması kanunen yasaktır.',
          subList: null
        },
        {
          paragraph:
            'Trafik sigortası yaptırmayan araç trafikte tespit edilirse araç bağlanır ve ceza uygulanır. Sigortasız trafikte yakalanan araçlar trafik polisleri tarafından men cezası alır ve ilgili araç otoparka çekilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Yeni Alınan Aracın Trafik Sigortası Kaç Gün İçinde Yapılmalı?',
      content: [
        {
          paragraph:
            'Yeni alınan aracın trafik sigortasını zaman kaybetmeden yaptırmalısınız.',
          subList: null
        },
        {
          paragraph:
            'İkinci el araç alan sürücüler ise noter satışını gerçekleştiğinde 15 gün içinde zorunlu trafik sigortasını yaptırmalıdır. Aksi takdirde aracınız sigortasız kalır ve olası riskler güvence altına alınmaz. Tüm bu durumların yanı sıra aracınız trafikte olursa, trafikten men cezası ile karşı karşıya kalırsınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası Ne Zaman Yenilenir?',
      content: [
        {
          paragraph:
            'Trafik sigortası yenileme süresi 1 yıldır. Sigorta başlangıç ve bitiş tarihleri poliçe üzerinde yer alır. Bu süreyi takip etmeli ve bitiş tarihine yakın trafik sigortası yenilemesi yaptırmalısınız.',
          subList: null
        },
        {
          paragraph:
            'Alokasko.com uzmanları tüm sigorta poliçelerini takip eder ve yenileme sürecine girdiğinizde en uygun fiyatları size sunar.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası Bitmeden Yenilenir Mi?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası poliçe süresi bitmesine bir ay kalması durumunda yenileme yapılabilir.',
          subList: null
        },
        {
          paragraph:
            'Bitiş tarihi kapsamında son 30 gününüz kalmışsa en ucuz trafik sigortası fiyatlarımızı değerlendirmeye başlayabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Olmadan Araç Satışı Yapılır Mı?',
      content: [
        {
          paragraph:
            'Noter satışlarında zorunlu trafik sigortası olmadan satış yapılmamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Araç satışı yapabilmek için trafik sigortasının olması gerekir. Satış yapıldıktan sonra alıcının kazaya karışması durumunda yaptırmış olduğunuz trafik sigortası tazminat ödemekle yükümlüdür.',
          subList: null
        }
      ]
    },
    {
      title: 'Noter Satışından Sonra Trafik Sigortası Kaç Gün Geçerli?',
      content: [
        {
          paragraph:
            'Noter satışı yapıldıktan sonra aracı alan kişi 15 gün içerisinde kendi adına trafik sigortası poliçesi satın almalıdır. Trafik sigortası yaptırmak için yeni araç sürücüsüne 15 gün süre tanınır.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Poliçesi Kimin Adına Yapılmalıdır?',
      content: [
        {
          paragraph:
            'Trafik poliçesi ruhsat sahibi adına düzenlenir ve aracın modeline göre farklı fiyat belirlenir.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası Fiyatları Neden Yüksek?',
      content: [
        {
          paragraph:
            'Trafik sigortası fiyatlarının yüksek çıkmasındaki en önemli faktörler:',
          subList: [
            'Plakanın ait olduğu il,',
            'Hasarsızlık basamağı,',
            'Araç sahibinin yaşı,',
            'Aracın markası,',
            'Poliçenin zamanında yenileni yenilenmediğidir.'
          ]
        },
        {
          paragraph:
            'Trafik sigortası fiyatları hesaplanırken hasar kaydınız bulunuyorsa yüksek primle karşılaşırsınız. Aynı zamanda poliçenizi zamanında yenilemezseniz gecikme zammı da uygulanır.',
          subList: null
        }
      ]
    },
    {
      title: 'Banka/Kredi Kartı İle Trafik Sigortası Satın Alabilir Miyim?',
      content: [
        {
          paragraph:
            'Trafik sigortanızı online veya müşteri hizmetlerini arayarak banka kartı ya da kredi kartı ile kolayca alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Sanal pos ile poliçe ödemelerini peşin ya da taksitli olarak kredi kartından otomatik ödeme yaparak işlem sağlamak için Alokasko.com uzmanlarından destek almanız yeterlidir. Bunun için trafik sigortası teklif formunu doldurabilirsiniz.              ',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortasını Taksitle Alabilir Miyim?',
      content: [
        {
          paragraph:
            'Evet, trafik sigortası poliçenizi kredi kartınıza 9 eşit taksitlerle yaptırabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '**Taksit sayıları bankaların anlaşmalarına göre değişkenlik gösterebilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Hangi Trafik Sigortası Şirketlerinden Teklif Alabilirim?',
      content: [
        {
          paragraph:
            'Alokasko.com ile 22 farklı sigorta şirketlerinden trafik sigortası veya farklı sigorta ürünlerinin tekliflerini online veya müşteri hizmetlerini arayarak alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Kısa Süreli Trafik Sigortası Yaptırabilir Miyim?',
      content: [
        {
          paragraph:
            'Kısa süreli poliçe aracın geçici plaka veya yabancı plaka olması durumunda yapılabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası Kazada Ne Kadar Öder?',
      content: [
        {
          paragraph:
            'Trafik sigortası sigortalı aracın kazaya sebep olması durumunda ve kusur oranına göre tazminat ödemesi sağlar.',
          subList: null
        },
        {
          paragraph:
            'Örnek bir kaza anında taraflardan bir % 50 diğeri %50 oranında kusurluysa sigorta şirketine çıkan tazminatın % 50 oranında ödeme yaparak hasar dosyasını kapatılıyor.',
          subList: null
        }
      ]
    },
    {
      title:
        'Trafik Sigortası Olmayan Aracın Kazaya Karışması Sonucunda Ne Olur?',
      content: [
        {
          paragraph:
            '<strong>Trafik sigortası olmayan araç</strong>: Aracın trafik sigortası yoksa karıştığı kazada %100 kusurlu olması durumunda üçüncü şahıslara verdiği zararın masraflarını sigorta şirketi ödeme yapmaz. Yapılan kazada sigortanız yoksa ve karşı sürücü kusurluysa meydana gelen zarar karşı tarafın sigorta şirketinden talep edebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '***Trafik sigortası olmayan araç kazaya karışırsa ve kusurlu olursa meydana gelen masrafları karşılamak durumundadır. Bu sebeple trafik sigortanız olmadan trafiğe çıkmamalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Alkollü Kazayı Öder Mi?',
      content: [
        {
          paragraph:
            'Trafik sigortası genel şartları ve kasko sigortası genel şartları doğrultusunda bakıldığı zaman <strong>alkollü kaza</strong> olayları sigorta şirketlerinin ve genel şartlardaki ağır kusur ihmal olarak adlandırılan madde üzerinden red olarak işleme alınır. Fakat karışmış olduğunuz kazada farklı bir araç kazaya sebebiyet veriyorsa ve kusurunuz yoksa o zaman tazminatlarınızı alabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Tek Taraflı Kazalarda Trafik Sigortası Ödeme Yapar Mı?',
      content: [
        {
          paragraph:
            'Kendi aracınızı kullanırken tek taraflı yapacağınız kazaları trafik sigortası karşılamamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Zorunlu trafik sigortası kapsamında karşılanan durumlar yalnızca üçüncü şahıslardır. Kendi aracınızın zarar ve hasarlarını karşılatmak istiyorsanız araç kasko sigortası yaptırmalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası Sorgulama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Mevcut sigorta poliçenizi E-Devlet üzerinden kolayca sorgulayabilirsiniz.',
          subList: [
            'Plakadan trafik sigortası sorgulama',
            'T.C. ile trafik sigortası sorgulama işlemi yapılmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'E-Devletten Zorunlu Trafik Sigortası Sorgulaması Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Sigorta Bilgi ve Gözetim Merkezi kapsamında Trafik Poliçe ve Hasar Bilgileri Sorgulama işlemi E-Devletten yapılabilmektedir. E-Devletten trafik sigortası sorgulaması yapmak için kimlik doğrulaması yapmanız gerekmektedir. Doğrulama sonucunda ise plakadan trafik sigortası sorgulaması ya da T.C. ile trafik sigortası sorgulama işlemi yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Tarife Basamak Kodu Nedir?        ',
      content: [
        {
          paragraph:
            'Hasarsızlık kademeleri yıllık baza bağlı olarak sürücünün trafikteki durumuna göre değişiklik göstermektedir. Zorunlu trafik sigortası basamakları sorgulama işlemi için yenileme döneminde fiyat talebinde bulunmanız yeterlidir. Hasarsız geçen yıl bitiminde en uygun kasko fiyatları ile karşılaşacaksınız.',
          subList: [
            'Zorunlu trafik sigortalarında basamaklar 7 kademeden oluşur.',
            'İlk kademe en yüksek primi işaret ederken 7. kademe en düşük primi ödeyen araç sürücülerini kapsar.'
          ]
        }
      ]
    },
    {
      title: 'Trafik Sigortası Hasarsızlık İndirimi Aktarımı Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Trafik sigortası veya kasko poliçesi hasarsızlık indirimi, sigorta şirketinde değişiklik yapsanız dahi devam eder. Sigorta poliçeniz sona erdiği an farklı sigorta şirketine geçebilirsiniz. Bu tamamen sizin tercihinize bağlıdır. Zamanında yenileme yaptığınız durumda yenileme hakkınızı kaybetmezsiniz.',
          subList: null
        }
      ]
    },
    // {  BURADA TABLO YAPISI OLACAK DAHA SONRA BAKILACAK
    //   title: 'Trafik Sigortası Hasarsızlık İndirimi Sorgulama Nasıl Yapılır?',
    //   content: [
    //     {
    //       paragraph:
    //         'Devlet destekli alacak sigortası, vadeli satışlardan elde edilen ciro ve vadenin süresine göre hesaplanmaktadır.',
    //       subList: null
    //     }
    //   ]
    // }
    {
      title: 'Engellilere Trafik Sigortası İndirimi Yapılır Mı?',
      content: [
        {
          paragraph:
            'Evet, Trafik sigortası kapsamında araç sahibi engelli ise engelli olarak ruhsat çıkartılır ve aracı kimin kullanacağı ruhsata yazılarak işleme alınır.',
          subList: null
        }
      ]
    },
    {
      title: 'En İyi Trafik Sigortası Hangisi?',
      content: [
        {
          paragraph:
            '<u>www.alokasko.com</u> olarak 22 farklı sigorta şirketinden sizlere en iyi fiyatlama ile hazırlayacağımız teklifi değerlendirerek zorunlu trafik sigortanızı seçebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'En Ucuz Zorunlu Trafik Sigortası Fiyatı Hangi Şirketten Alınır?',
      content: [
        {
          paragraph:
            'En ucuz trafik sigortasını Türkiye’de bulunan tüm sigorta şirketlerinden sizin adınıza araştıran <u>www.alokasko.com</u> adresinden karşılaştırmalı olarak görüntüleyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Şirketler Arası Trafik Sigortası Kampanyaları Nelerdir?',
      content: [
        {
          paragraph:
            'Genellikle trafik sigortalarında sigorta şirketleri serbest piyasa koşullarında prim tutarları üzerinden kampanya hazırlar. Bunun dışında kredi kartına taksit sayılarını artırabilmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Online Trafik Sigortası Almanın Avantajları Nelerdir?        ',
      content: [
        {
          paragraph:
            'Online trafik sigortası veya kasko sigortası almanız size avantaj sağlar.',
          subList: null
        },
        {
          paragraph:
            'Siz değerli müşterilerimize katacağı avantajlar arasında alokasko.com olarak sizler için 22 farklı sigorta şirketinin fiyatını karşılaştırarak en ucuz teklifi sunmaktayız. Bununla birlikte kampanyalarımızdan yararlanarak avantajlarınızı arttırabiliyorsunuz.',
          subList: null
        },
        {
          paragraph:
            'Hem zamandan hem de primden avantaj sağlamak için online trafik sigortası teklifi alın!',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası İptali Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası iptali iki farklı şekilde yapılabilir.',
          subList: null
        },
        {
          paragraph:
            'Birincisi aracınızı satmanız durumunda noter satış belgesini ibraz ederek poliçe iptalini yaptırabilirsiniz. İkinci durum ise aracınızı trafikten çekerek çekme belgesini ibraz etmeniz durumunda trafik sigortası iptali yaptırabilirsiniz. ',
          subList: null
        }
      ]
    },
    {
      title: 'Araç Değer Kaybını Trafik Sigortası Karşılar Mı?',
      content: [
        {
          paragraph:
            'Araç değer kaybını zorunlu trafik sigortası karşılar. Değer kaybı alabilmeniz için kaza yaptığınızda kusursuz olmanız gerekmektedir.              ',
          subList: null
        },
        {
          paragraph:
            'Karşı tarafın trafik poliçesinden sigorta şirketine başvuru yaparak değer kaybınızı tahsil edebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Hasar Karşılama Şartları Nelerdir?',
      content: [
        {
          paragraph:
            'Trafik sigortasının bir hasarı karşılaması için ilgili belge ve evrakların eksiksiz bir şekilde iletilmesi gerekmektedir.',
          subList: [
            'Kaza oluştuğunda kaza tespit tutanağı veya tek taraflı kaza ise beyan yazmanız.',
            'Hasarın olduğu zamanı ve tarihe dikkat etmeniz.',
            'Kaza yeri ve hasar alan aracın geniş açılardan fotoğraflarının çekilmiş olmasına.',
            'Tarafların ifadeleri ve iletişim bilgilerinin doğru olduğuna.',
            'Özellikle sigorta poliçesi fotokopisi evraklar arasında yer aldığına dikkat etmeniz gerekmektedir. Tüm evrakları doğru ve zamanında teslim etmeniz durumunda gerekli işlemleriniz hızlı bir şekilde çözüme kavuşacaktır.'
          ]
        }
      ]
    },
    {
      title: 'Trafik Sigortası Hasar Karşılama Limiti Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası 2021 yılı maddi limit 43.000 TL olarak hasarınızı karşılamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Bedeni, sakatlık ölüm, limitleri kusur oranlarına göre değişiklik göstermektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Cam Kırılmasını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Aracınıza yaptırmış olduğunuz trafik sigortası poliçesi kendi aracınızın cam kırılmasını karşılamamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Kendi aracınızın cam ve ön cam hasarlarını alabilmeniz için kasko poliçesi yaptırmanız gerekir.',
          subList: null
        },
        {
          paragraph:
            'Sizin üçüncü şahıs aracına verdiğiniz hasar durumunda karşı tarafın hasarını ve cam kırılmasını karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Doğal Afeti Karşılar Mı?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası her hangi bir kaza anında ve kazada kusurlu olmanız durumunda karşı tarafın hasarını karşılamaktadır. Doğal afetten dolayı aracınızın başına gelecek hasarı kasko poliçesi karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Yangını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası bir kazaya karışmanız durumunda ve kazada kusur oranınız yok ise kazaya sebebiyet veren aracın trafik sigortasından aracınızın başına gelen tüm harları buna yangında dâhil olmak üzere karşılar.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Kendi Hasarını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Trafik sigortası kendi hasarınızı karşılamaz. Kendi aracınızın hasarlarını araç kasko sigortası karşılar.',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Çalınmayı Karşılar Mı?',
      content: [
        {
          paragraph:
            'Trafik sigortası kendi hasarınızı veya aracınızın çalınmasını <strong>karşılamaz</strong>.',
          subList: null
        },
        {
          paragraph:
            'Zorunlu trafik sigortası sizin üçüncü şahıslara verdiğiniz hasarı karşılar. Aracınızı oluşabilecek zararlara veya çalınmaya karşı güvence altına almak için kasko sigortası yaptırmanız gerekmektedir.              ',
          subList: null
        }
      ]
    },
    {
      title: 'Trafik Sigortası Muhasebe Kaydı Nedir?',
      content: [
        {
          paragraph:
            'Trafik sigortası veya kasko sigortası yaptırdığınızda poliçenizi muhasebecinize iletmeniz durumunda muhasebe kaydınızı yapacaktır.',
          subList: null
        },
        {
          paragraph:
            'Muhasebe kaydı tutulurken gerekli olan standart bilgiler:',
          subList: [
            'Poliçenin Başlangıç Tarihi',
            'Poliçenin Bitiş Tarihi',
            'Poliçe Bedeli',
            'Poliçenin Ödeme Şeklidir.'
          ]
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası Yaptırmamanın Cezası Nedir?',
      content: [
        {
          paragraph:
            'Zorunlu trafik sigortası yaptırmamanın cezası bulunmaktadır. Poliçe bitinden sonra her ay % 5 artarak ilerler.',
          subList: null
        },
        {
          paragraph:
            ' Trafik poliçenizi gününde yaptırmak sizin için daha avantajlı olacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'İnternetten Trafik Sigortası Yaptırmak Güvenli Mi?',
      content: [
        {
          paragraph:
            '<u>Alokasko.com</u> ekibi 22 farklı sigorta şirketinden en ucuz poliçeyi anında bulmanızı sağlar. Güvenli bir ödeme yöntemi ile sigortanızı kolayca satın alabilirsiniz. Kart bilgileriniz dahil ileteceğiniz tüm bilgiler tarafımızda güvenle saklanır.',
          subList: null
        }
      ]
    },
    {
      title: 'En Uygun Zorunlu Trafik Sigortası Nasıl Bulunur?',
      content: [
        {
          paragraph:
            'Yaptırılması kanunen zorunlu olan trafik sigortası poliçenizi en ucuz fiyattan satın almak için tüm sigorta şirketlerinden fiyat teklifinde bulunmanız gerekir.',
          subList: null
        },
        {
          paragraph:
            'Aracınıza özel hazırlanacak trafik sigortası fiyatlarını öğrenmek için teklif formumuzu doldurmanız yeterlidir. İster online ister offline poliçe satın alabilirsiniz. Kart bilgilerinizi web sitesi üzerinden doldurarak satın alma yapmak istemiyorsanız müşteri danışmanlarımız size yardımcı olabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Zorunlu Trafik Sigortası Teklifi Nasıl Alınır?        ',
      content: [
        {
          paragraph:
            '<u>www.alokasko.com</u> sizin için 22 farklı sigorta şirketinden en ucuz poliçeyi bulur.',
          subList: null
        },
        {
          paragraph:
            'Trafik sigortası fiyatı almak için online teklif formunu doldurabilir veya <strong><em><u>0216 371 67 77</u></em></strong> numaralı hattan müşteri hizmetlerini arayarak poliçenizi en ucuza alabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
